/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const heroOverlayNodes = Array.from(document.querySelectorAll('.hero-overlay'));
if (heroOverlayNodes.length) {
    import(/* webpackChunkName: "HeroOverlay" */ './components/HeroOverlay').then(({ default: HeroOverlay }) => {
        heroOverlayNodes.forEach((node) => render(<HeroOverlay {...parseDataToProps(node.dataset)} />, node));
    });
}
